// import React, { useEffect, useState } from "react";
// import styles from "./styles.module.css";
// import { useMatchMedia } from "../Sections/Hooks/useMatchMedia";
// export const WistiaHero = ({
//   id,
//   content,
//   theme = null,
//   height = null,
//   video = {},
//   mobId = null,
// }) => {
//   const [isDesktop] = useMatchMedia("(min-width: 775px)", true);
//   const [windowWidth, setWindowWidth] = useState(0);
//   const [color, setColor] = React.useState(
//     theme?.backgroundColorInvert ? "#FFFFFF" : "#000000"
//   );
//   const [textColor, setTextColor] = React.useState(
//     theme?.backgroundColorInvert ? theme?.backgroundColor : "#000000"
//   );
//   useEffect(() => {
//     setWindowWidth(window.innerWidth);
//     const onMouseEnter = () => {
//       setColor(
//         theme?.backgroundColorInvert ? theme?.backgroundColor : "#000000"
//       );
//       setTextColor(theme?.backgroundColorInvert ? "#FFFFFF" : "#000000");
//     };

//     const onMouseLeave = () => {
//       setColor(theme?.backgroundColorInvert ? "#FFFFFF" : "#000000");
//       setTextColor(
//         theme?.backgroundColorInvert ? theme?.backgroundColor : "#000000"
//       );
//     };

//     document
//       .getElementById("WistiaEmbedTrigger")
//       ?.addEventListener("mouseenter", onMouseEnter);
//     document
//       .getElementById("WistiaEmbedTrigger")
//       ?.addEventListener("mouseleave", onMouseLeave);
//   }, []);
//   // if (!id.desktop) return null
//   const wistiaVideo = `//fast.wistia.net/embed/iframe/${
//     isDesktop ? id : mobId
//   }?videoFoam=true`;
//   return (
//     <section className={styles.cover}>
//       <div className={styles.holder}>
//         {video?.src && video?.mob ? (
//           <video
//             className={styles.videoEmbbed}
//             poster={video.poster}
//             frameBorder="0"
//             width={windowWidth}
//             height={"auto"}
//             autoPlay={true}
//             muted
//             playsInline
//             controls
//             loop
//             src={isDesktop ? video.src : video.mob}
//           >
//             <track src="" kind="captions" />
//           </video>
//         ) : video?.src ? (
//           <>
//             {isDesktop ? (
//               <video
//                 className={styles.videoEmbbed}
//                 poster={video.poster}
//                 frameBorder="0"
//                 width={windowWidth}
//                 height={"auto"}
//                 autoPlay={true}
//                 muted
//                 playsInline
//                 controls
//                 loop
//                 src={video.src}
//               >
//                 <track src="" kind="captions" />
//               </video>
//             ) : mobId ? (
//               <iframe
//                 src={wistiaVideo}
//                 allowtransparency="true"
//                 frameborder="0"
//                 scrolling="no"
//                 className="wistia_embed"
//                 name="wistia_embed"
//                 autoPlay
//                 allowfullscreen
//                 mozallowfullscreen
//                 webkitallowfullscreen
//                 oallowfullscreen
//                 msallowfullscreen
//                 width={windowWidth}
//                 height={
//                   height || windowWidth / 2 + (windowWidth / 2) * 0.7 || 0
//                 }
//               ></iframe>
//             ) : (
//               <video
//                 className={styles.videoEmbbed}
//                 poster={video.poster}
//                 frameBorder="0"
//                 width={windowWidth}
//                 height={"auto"}
//                 autoPlay={true}
//                 muted
//                 playsInline
//                 controls
//                 loop
//                 src={video.src}
//               >
//                 <track src="" kind="captions" />
//               </video>
//             )}
//           </>
//         ) : (
//           <>
//             <iframe
//               src={wistiaVideo}
//               allowtransparency="true"
//               frameborder="0"
//               scrolling="no"
//               className="wistia_embed"
//               name="wistia_embed"
//               autoPlay
//               allowfullscreen
//               mozallowfullscreen
//               webkitallowfullscreen
//               oallowfullscreen
//               msallowfullscreen
//               width={windowWidth}
//               height={height || windowWidth / 2 + (windowWidth / 2) * 0.2 || 0}
//             ></iframe>
//             <script
//               src="//fast.wistia.net/assets/external/E-v1.js"
//               async
//             ></script>
//           </>
//         )}
//         {content && (
//           <div className={styles.conatiner}>
//             <div className={styles.heroButtonAndTextContainer}>
//               <div className={styles.titleHolder}>
//                 {content?.title && (
//                   <div
//                     className={styles.title}
//                     dangerouslySetInnerHTML={{ __html: content.title }}
//                   />
//                 )}
//                 {content?.subTitle && (
//                   <div className={styles.subTitle}>{content.subTitle}</div>
//                 )}
//               </div>
//               {content?.btnText && (
//                 <a href={content.btnLink || "/collezioni/tutti"}>
//                   <span className={styles.btn}>{content.btnText}</span>
//                 </a>
//               )}
//             </div>
//             {content.buyNow && (
//               <span
//                 className={styles.buyNow}
//                 id="WistiaEmbedTrigger"
//                 onClick={content.ModalHandler}
//                 style={{ background: color, color: textColor }}
//               >
//                 Buy Now
//               </span>
//             )}
//           </div>
//         )}
//         {content?.headTitle && (
//           <div
//             className={styles.headTitle}
//             dangerouslySetInnerHTML={{ __html: content.headTitle }}
//           />
//         )}
//       </div>
//     </section>
//   );
// };

// import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet-async";
// import styles from "./styles.module.css";
// import { useMatchMedia } from "../Sections/Hooks/useMatchMedia";

// export const WistiaHero = ({
//   id,
//   content,
//   theme = null,
//   height = null,
//   video = {},
//   mobId = null,
//   // Optional override props
//   title: propTitle = "",
//   description: propDescription = "",
//   uploadDate = "",
//   duration = "",
//   thumbnailUrl: propThumbnailUrl = "",
//   watchPageUrl = "",
//   contentUrl: propContentUrl = "",
//   addStructuredData = false,
// }) => {
//   const [isDesktop] = useMatchMedia("(min-width: 775px)", true);
//   const [windowWidth, setWindowWidth] = useState(0);
//   const [color, setColor] = React.useState(
//     theme?.backgroundColorInvert ? "#FFFFFF" : "#000000"
//   );
//   const [textColor, setTextColor] = React.useState(
//     theme?.backgroundColorInvert ? theme?.backgroundColor : "#000000"
//   );

//   useEffect(() => {
//     setWindowWidth(window.innerWidth);

//     const onMouseEnter = () => {
//       setColor(
//         theme?.backgroundColorInvert ? theme?.backgroundColor : "#000000"
//       );
//       setTextColor(theme?.backgroundColorInvert ? "#FFFFFF" : "#000000");
//     };

//     const onMouseLeave = () => {
//       setColor("#FFFFFF");
//       setTextColor(
//         theme?.backgroundColorInvert ? theme?.backgroundColor : "#000000"
//       );
//     };

//     const trigger = document.getElementById("WistiaEmbedTrigger");
//     trigger?.addEventListener("mouseenter", onMouseEnter);
//     trigger?.addEventListener("mouseleave", onMouseLeave);

//     return () => {
//       trigger?.removeEventListener("mouseenter", onMouseEnter);
//       trigger?.removeEventListener("mouseleave", onMouseLeave);
//     };
//   }, [
//     isDesktop,
//     id,
//     mobId,
//     video,
//     content,
//     theme,
//     propTitle,
//     propDescription,
//     addStructuredData,
//   ]);

//   // Final values with fallback logic
//   const finalTitle = propTitle || video?.title || "Product Hero Video";
//   const finalDescription = propDescription || video?.description || "";
//   const finalThumbnailUrl = propThumbnailUrl || video?.poster || "";

//   const finalContentUrl = propContentUrl || video?.src || "";

//   const generateStructuredData = () => {
//     if (!finalTitle || !finalDescription || !addStructuredData) return null;

//     return {
//       "@context": "https://schema.org",
//       "@type": "VideoObject",
//       name: finalTitle,
//       description: finalDescription,
//       thumbnailUrl: finalThumbnailUrl,
//       uploadDate: uploadDate || new Date().toISOString(),
//       contentUrl: finalContentUrl,
//       duration: duration || "",
//       url:
//         watchPageUrl ||
//         (typeof window !== "undefined" ? window.location.href : ""),
//     };
//   };

//   const wistiaVideo = `//fast.wistia.net/embed/iframe/${
//     isDesktop ? id : mobId
//   }?videoFoam=true`;

//   const structuredData = generateStructuredData();

//   return (
//     <>
//       {/* SEO & Structured Data */}
//       {addStructuredData && structuredData && (
//         <Helmet>
//           <script type="application/ld+json">
//             {JSON.stringify(structuredData)}
//           </script>

//           <meta name="robots" content="max-video-preview:-1" />
//           <meta property="og:type" content="video.other" />
//           <meta property="og:title" content={finalTitle} />
//           <meta property="og:description" content={finalDescription} />
//           <meta property="og:image" content={finalThumbnailUrl} />
//           {finalContentUrl && (
//             <>
//               <meta property="og:video" content={finalContentUrl} />
//               <meta property="og:video:secure_url" content={finalContentUrl} />
//             </>
//           )}
//         </Helmet>
//       )}

//       <section className={styles.cover}>
//         <div className={styles.holder}>
//           {/* Video Rendering Logic */}
//           {video?.src && video?.mob ? (
//             <video
//               className={styles.videoEmbbed}
//               poster={video.poster}
//               width={windowWidth}
//               height="auto"
//               autoPlay
//               muted
//               playsInline
//               controls
//               loop
//               src={isDesktop ? video.src : video.mob}
//               itemScope
//               itemType="https://schema.org/VideoObject"
//             >
//               <track src="" kind="captions" />
//             </video>
//           ) : video?.src ? (
//             <>
//               {isDesktop ? (
//                 <video
//                   className={styles.videoEmbbed}
//                   poster={video.poster}
//                   width={windowWidth}
//                   height="auto"
//                   autoPlay
//                   muted
//                   playsInline
//                   controls
//                   loop
//                   src={video.src}
//                   itemScope
//                   itemType="https://schema.org/VideoObject"
//                 >
//                   <track src="" kind="captions" />
//                 </video>
//               ) : mobId ? (
//                 <iframe
//                   src={wistiaVideo}
//                   allowTransparency="true"
//                   frameBorder="0"
//                   scrolling="no"
//                   className="wistia_embed"
//                   name="wistia_embed"
//                   autoPlay
//                   allowFullScreen
//                   width={windowWidth}
//                   height={height || windowWidth / 2 + (windowWidth / 2) * 0.7}
//                   title={finalTitle}
//                 />
//               ) : (
//                 <video
//                   className={styles.videoEmbbed}
//                   poster={video.poster}
//                   width={windowWidth}
//                   height="auto"
//                   autoPlay
//                   muted
//                   playsInline
//                   controls
//                   loop
//                   src={video.src}
//                 >
//                   <track src="" kind="captions" />
//                 </video>
//               )}
//             </>
//           ) : (
//             <>
//               <iframe
//                 src={wistiaVideo}
//                 allowTransparency="true"
//                 frameBorder="0"
//                 scrolling="no"
//                 className="wistia_embed"
//                 name="wistia_embed"
//                 autoPlay
//                 allowFullScreen
//                 width={windowWidth}
//                 height={height || windowWidth / 2 + (windowWidth / 2) * 0.2}
//                 title={finalTitle}
//               />
//               <script src="//fast.wistia.net/assets/external/E-v1.js" async />
//             </>
//           )}

//           {/* Text Overlay & Buy Now Button */}
//           {content && (
//             <div className={styles.conatiner}>
//               <div className={styles.heroButtonAndTextContainer}>
//                 <div className={styles.titleHolder}>
//                   {content?.title && (
//                     <div
//                       className={styles.title}
//                       dangerouslySetInnerHTML={{ __html: content.title }}
//                     />
//                   )}
//                   {content?.subTitle && (
//                     <div className={styles.subTitle}>{content.subTitle}</div>
//                   )}
//                 </div>
//                 {content?.btnText && (
//                   <a href={content.btnLink || "/collezioni/tutti"}>
//                     <span className={styles.btn}>{content.btnText}</span>
//                   </a>
//                 )}
//               </div>
//               {content.buyNow && (
//                 <span
//                   className={styles.buyNow}
//                   id="WistiaEmbedTrigger"
//                   onClick={content.ModalHandler}
//                   style={{ background: color, color: textColor }}
//                 >
//                   Buy Now
//                 </span>
//               )}
//             </div>
//           )}
//           {content?.headTitle && (
//             <div
//               className={styles.headTitle}
//               dangerouslySetInnerHTML={{ __html: content.headTitle }}
//             />
//           )}
//         </div>
//       </section>
//     </>
//   );
// };

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import styles from "./styles.module.css";
import { useMatchMedia } from "../Sections/Hooks/useMatchMedia";

export const WistiaHero = ({
  id,
  content,
  theme = null,
  height = null,
  video = {},
  mobId = null,
  title: propTitle = "",
  description: propDescription = "",
  uploadDate = "",
  duration = "",
  thumbnailUrl: propThumbnailUrl = "",
  watchPageUrl = "",
  contentUrl: propContentUrl = "",
  addStructuredData = false,
}) => {
  const [isDesktop] = useMatchMedia("(min-width: 775px)", true);
  const [windowWidth, setWindowWidth] = useState(0);

  const [color, setColor] = useState(
    theme?.backgroundColorInvert ? "#FFFFFF" : "#000000"
  );
  const [textColor, setTextColor] = useState(
    theme?.backgroundColorInvert ? theme?.backgroundColor : "#000000"
  );

  useEffect(() => {
    setWindowWidth(window.innerWidth);

    const trigger = document.getElementById("WistiaEmbedTrigger");
    if (!trigger) return;

    const onMouseEnter = () => {
      setColor(
        theme?.backgroundColorInvert ? theme?.backgroundColor : "#000000"
      );
      setTextColor(theme?.backgroundColorInvert ? "#FFFFFF" : "#000000");
    };

    const onMouseLeave = () => {
      setColor("#FFFFFF");
      setTextColor(
        theme?.backgroundColorInvert ? theme?.backgroundColor : "#000000"
      );
    };

    trigger.addEventListener("mouseenter", onMouseEnter);
    trigger.addEventListener("mouseleave", onMouseLeave);

    return () => {
      trigger.removeEventListener("mouseenter", onMouseEnter);
      trigger.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [theme]);

  const finalTitle = propTitle || video?.title || "Product Video";
  const finalDescription = propDescription || video?.description || "";
  const rawThumbnailUrl = propThumbnailUrl || video?.poster || "";

  const absoluteThumbnailUrl = rawThumbnailUrl
    ? `https://brunomd.com${
        rawThumbnailUrl.startsWith("/") ? "" : "/"
      }${rawThumbnailUrl}`
    : "";

  const currentVideoSrc =
    video?.src && video?.mob
      ? isDesktop
        ? video.src
        : video.mob
      : video?.src || propContentUrl || "";

  const finalUploadDate = uploadDate || "2025-12-23T09:00:35Z";

  const structuredData =
    addStructuredData && finalTitle && finalDescription && currentVideoSrc
      ? {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          name: finalTitle,
          description: finalDescription,
          thumbnailUrl: absoluteThumbnailUrl,
          uploadDate: finalUploadDate,
          contentUrl: currentVideoSrc,
          duration: duration || undefined,
          url:
            watchPageUrl ||
            (typeof window !== "undefined" ? window.location.href : ""),
        }
      : null;

  const wistiaVideo = `https://fast.wistia.net/embed/iframe/${
    isDesktop ? id : mobId
  }?videoFoam=true`;

  return (
    <>
      {structuredData && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>

          <meta name="robots" content="max-video-preview:-1" />
          <meta property="og:type" content="video.other" />
          <meta property="og:title" content={finalTitle} />
          <meta property="og:description" content={finalDescription} />
          <meta property="og:image" content={absoluteThumbnailUrl} />
          <meta property="og:video" content={currentVideoSrc} />
          <meta property="og:video:secure_url" content={currentVideoSrc} />
        </Helmet>
      )}

      {/* ---------- UI ---------- */}
      <section className={styles.cover}>
        <div className={styles.holder}>
          {video?.src ? (
            <video
              className={styles.videoEmbbed}
              poster={absoluteThumbnailUrl}
              width={windowWidth}
              height="auto"
              autoPlay
              muted
              playsInline
              controls
              loop
              src={currentVideoSrc}
              itemProp="contentUrl"
              aria-label={finalTitle}
            >
              <track kind="captions" />
            </video>
          ) : (
            <iframe
              src={wistiaVideo}
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
              width={windowWidth}
              height={height || windowWidth * 0.56}
              title={finalTitle}
            />
          )}

          {content && (
            <div className={styles.conatiner}>
              <div className={styles.heroButtonAndTextContainer}>
                <div className={styles.titleHolder}>
                  {content?.title && (
                    <div
                      className={styles.title}
                      dangerouslySetInnerHTML={{ __html: content.title }}
                    />
                  )}
                  {content?.subTitle && (
                    <div className={styles.subTitle}>{content.subTitle}</div>
                  )}
                </div>

                {content?.btnText && (
                  <a href={content.btnLink || "/"}>
                    <span className={styles.btn}>{content.btnText}</span>
                  </a>
                )}
              </div>

              {content.buyNow && (
                <span
                  id="WistiaEmbedTrigger"
                  className={styles.buyNow}
                  style={{ background: color, color: textColor }}
                  onClick={content.ModalHandler}
                >
                  Buy Now
                </span>
              )}
            </div>
          )}
        </div>
      </section>
    </>
  );
};
